import apiService from './ApiService';

const AsistenteService = {
  /**
   * Obtiene la lista de asistentes del usuario actual
   * @returns {Promise} Promesa que resuelve con la respuesta de la API
   */
  async getMisAsistentes(options = {}) {
    try {
      const params = new URLSearchParams();
      if (Number.isFinite(options.start)) params.append('start', options.start);
      if (Number.isFinite(options.end)) params.append('end', options.end);
      if (typeof options.esClasico === 'boolean') params.append('esClasico', String(options.esClasico));
      if (typeof options.esAsignado === 'boolean') params.append('esAsignado', String(options.esAsignado));
      const query = params.toString();

      const response = await apiService.request(`/Asistente/mis-asistentes${query ? `?${query}` : ''}`, {
        method: 'GET'
      });
      
      
      // Validar estructura de respuesta
      if (!response.ok) {
        throw new Error(response.error || 'Error al obtener los asistentes');
      }
      
      // Procesar fechas en los asistentes
      if (response.asistentes && Array.isArray(response.asistentes)) {
        response.asistentes = response.asistentes.map(asistente => ({
          ...asistente,
          fechaAlta: asistente.fechaAlta ? new Date(asistente.fechaAlta) : null
        }));
      }

      response.total = response.total ?? response.asistentes?.length ?? 0;
      
      return response;
      
    } catch (error) {
      console.error('❌ Error al obtener asistentes:', error);
      throw error;
    }
  },

  async getMisAsistentesReportesClasicos(options = {}) {
    try {
      const params = new URLSearchParams();
      if (Number.isFinite(options.start)) params.append('start', options.start);
      if (Number.isFinite(options.end)) params.append('end', options.end);
      if (typeof options.esAsignado === 'boolean') params.append('esAsignado', String(options.esAsignado));
      const query = params.toString();

      const response = await apiService.request(`/Asistente/mis-asistentes-reportes-clasicos${query ? `?${query}` : ''}`, {
        method: 'GET'
      });

      if (!response.ok) {
        throw new Error(response.error || 'Error al obtener asistentes clásicos');
      }
      response.total = response.total ?? response.asistentes?.length ?? 0;
      return response;
    } catch (error) {
      console.error('❌ Error al obtener asistentes clásicos para reportes:', error);
      throw error;
    }
  },

  /**
   * Elimina un asistente por su ID
   * @param {string} assistantId - ID del asistente aliminar
   * @returns {Promise} Promesa que resuelve con la respuesta de la API
   */
  async eliminarAsistente(assistantId) {
    try {
      
      const response = await apiService.request(`/Asistente/eliminar/${assistantId}`, {
        method: 'DELETE'
      });
      
      
      if (!response.ok) {
        throw new Error(response.error || 'Error al eliminar el asistente');
      }
      
      return response;
      
    } catch (error) {
      console.error('❌ Error al eliminar asistente:', error);
      throw error;
    }
  },

  async eliminarAsistenteOpenAI(idOpenAIAssistant) {
    try {
      const response = await apiService.request(`/Asistente/${idOpenAIAssistant}`, {
        method: 'DELETE'
      });

      if (!response.ok) {
        throw new Error(response.error || 'Error al eliminar el asistente');
      }

      return response;
    } catch (error) {
      console.error('❌ Error al eliminar asistente OpenAI:', error);
      throw error;
    }
  },

  /**
   * Crea un nuevo asistente con archivos PDF
   * @param {FormData} formData - FormData con nombre del asistente y archivos PDF
   * @returns {Promise} Promesa que resuelve con la respuesta de la API
   */
  async crearAsistente(formData) {
    try {
      const response = await apiService.request('/Asistente/crear-openai', {
        method: 'POST',
        body: formData,
        // No establecer Content-Type para FormData, el navegador lo hará automáticamente
        headers: {}
      });
      
      if (!response.ok) {
        throw new Error(response.error || 'Error al crear el asistente');
      }
      
      return response;
      
    } catch (error) {
      console.error('❌ Error al crear asistente:', error);
      throw error;
    }
  },

  async getAsistenteById(idOpenAIAssistant) {
    try {
      
      const response = await apiService.get(`/Asistente/${idOpenAIAssistant}`);
      
      if (!response.ok) {
        throw new Error(response.error || 'Error al obtener el asistente');
      }
      
      return response;
    } catch (error) {
      console.error('❌ Error al obtener asistente:', error);
      throw error;
    }
  },

  async getAsistentePublicoPorNickname(nickname, colegioNombreUrl) {
    if (!nickname) {
      throw new Error('No se encontró el nickname del asistente.');
    }
    if (!colegioNombreUrl) {
      throw new Error('No se encontró el colegio.');
    }
    const params = new URLSearchParams();
    params.append('asistente', nickname);
    params.append('colegio', colegioNombreUrl);
    const response = await apiService.getPublic(`/Asistente/publico/por-nickname?${params.toString()}`);
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos obtener el asistente.';
      throw new Error(msg);
    }
    return response;
  },

  async actualizarAsistente(idOpenAIAssistant, formData) {
    try {
      const response = await apiService.request(`/Asistente/openai/${idOpenAIAssistant}`, {
        method: 'PUT',
        body: formData,
        headers: {}
      });

      if (!response.ok) {
        throw new Error(response.error || 'Error al actualizar el asistente');
      }

      return response;
    } catch (error) {
      console.error('❌ Error al actualizar asistente:', error);
      throw error;
    }
  }
};

export default AsistenteService;
